import React, {useEffect, useState} from 'react';
import ExpenseTable from '../../components/expense/Table';
import BudgetHistoryWidget from '../../components/expense/BudgetHistoryWidget';
import {InfoCard, InfoCardProps} from '../../components/core/InfoCard';
import {ActiveIcon, ProfileIcon} from '../../assets/icons';
import {getBudgetHistory, getExpenseStats} from '../../backend-services';
import {useExpenseStore} from '../../state';
import {useExpenseSearch} from '../../hooks';
import shallow from "zustand/shallow";


interface ExpenseStatsData {
  totalExpenses: number;
  totalExpenseValue: number;
  totalBillableExpenseValue: number;
  totalBillableExpenses: number;
  totalNonBillableExpenseValue: number;
  totalNonBillableExpenses: number;
}

const ViewExpensePage = () => {

  const [expenseStatsData, setExpenseStats] = React.useState<ExpenseStatsData>({
    totalExpenses: 0,
    totalExpenseValue: 0,
    totalBillableExpenseValue: 0,
    totalBillableExpenses: 0,
    totalNonBillableExpenseValue: 0,
    totalNonBillableExpenses: 0,
  });

  const [isBudgetLoading, setIsBudgetLoading] = useState<boolean>(false)

  const fetchExpenseStats = async () => {
    const response = await getExpenseStats();
    setExpenseStats(response);
  };


  const { fetchExpenses, fetchMoreData, onSearchData, handleFilter, fetchData, handleSort } = useExpenseStore(
    (state) => ({
      fetchExpenses: state.fetchExpenses,
      fetchMoreData: state.fetchMoreData,
      onSearchData: state.setSearchText,
      handleFilter: state.setFilter,
      fetchData: state.fetchData,
      handleSort: state.handleSort,
      setFilter: state.setFilter,
    }),
    shallow,
  );

  const { expenses, isLoading, range, pagination, searchText, filter } = useExpenseStore(
    (state) => ({
      expenses: state.expenses,
      isLoading: state.isLoading,
      filter: state.filter,
      searchText: state.searchText,
      range: state.range,
      pagination: state.pagination,
      error: state.error,
    }),
    shallow,
  );
 
 
  const { data: searchResult, isSearching, handleSearch: handleExpenseSearch } = useExpenseSearch();


  React.useEffect(() => {
    fetchData()
  }, [searchText, filter, range, fetchData]);
   const getBudget = React.useCallback(async () => {
    const date = new Date().toISOString();
      const startMonthYear = date.split('T')[0].slice(0, 7).split('-').reverse().join('-');
      const endMonthYear = date.split('T')[0].slice(0, 7).split('-').reverse().join('-');
      setIsBudgetLoading(true)
    return await getBudgetHistory(startMonthYear, endMonthYear);
  }, []); 

  useEffect(() => {
    fetchExpenses();
  }, []);

  useEffect(() => {
    fetchExpenseStats();
  }, []);

  const infoCardData = [
    {
      title: 'Total ',
      value: `${expenseStatsData.totalExpenses}`,
      color: 'secondary',
      icon: <ProfileIcon />,
      isLoading: isLoading,
    },
    {
      title: 'Average Value',
      value: `${expenseStatsData. totalExpenseValue}`,
      color: 'danger',
      icon: <ActiveIcon />,
      isLoading: isLoading,
    },
  ] as InfoCardProps[];
 
  return (
    <>
     <div className='flex flex-col allign-center '>
    <div className='flex justify-between items-center'>
      <h1 className="font-bold text-[18px] 540:ml-[3em] 412:ml-[-0.3em] 414:ml-[-0.1em] sm:ml-[5em] ml-[-1.6em] bigmd:ml-[2.4em] xl:text-[20px] lg:ml-[0.3em] md:ml-[2.8em] xl:ml-[0.1em] 360:ml-[-2.1em] 375:ml-[-1.5em]">Expenses</h1>
      <p className='text-[12px] 2xl:text-[14px] 540:mr-[3em]  md:mr-[2.4em] bigmd:mr-[2.2em] 375:mr-[-3.5em] 414:mr-[-2.2em] 360:mr-[-3.3em] 412:mr-[-1.2em] mr-[-1.7em]'>Last 30 days</p>
    </div>

      <div className="items-center flex justify-start ">
        <div className=" xl:ml-[-9em] xl:mt-[3.3em] biglg:ml-[1em] md:ml-[2.9em] bigmd:ml-[-5.9em] ml-[-1.9em] ">
          <BudgetHistoryWidget getBudget={getBudget}/>
        </div>
    <div className='hidden lg:block xl:mt-[6.7em] biglg:mt-[2.6em] lg:mt-[4.3em]  '>
  <div className="grid grid-cols-2 gap-3 xl:ml-[0.5em] biglg:ml-[-1.6em] lg:ml-[-4.2em] ">
    {infoCardData.map((cardData, index) => (
      <div className='' key={index}>
        <InfoCard {...cardData} />
      </div>
    ))}
    {infoCardData.length < 2 &&
      Array.from({ length: 2 - infoCardData.length }).map((_, index) => (
        <div key={index}></div>
      ))}
  </div>
</div>
    
      </div>
     <div className=" lg:hidden mt-6 ">
  <div className="flex justify-center md:ml-[0.5em] bigmd:w-[] gap-2 sm:gap-8 sm:ml-[-0.3em] ml-[1.5em] 375:ml-[0.2em] 414:ml-[0.3em] 360:ml-[0.2em] 412:ml-[-0.1em] smmd:">
  {infoCardData.slice(0, 2).map((cardData, index) => (
    <div key={index}>
      <InfoCard {...cardData} />
    </div>
  ))}
</div>
<div className="mt-6 md:mt-2"></div>
<div className="flex justify-center md:ml-[0.5em] gap-2 sm:gap-8 sm:ml-[-0.3em] ml-[-2em] 375:ml-[0.2em]  414:ml-[0.3em] 360:ml-[0.2em] 412:ml-[-0.1em]">
  {infoCardData.slice(2, 4).map((cardData, index) => (
    <div key={index}>
      <InfoCard {...cardData} />
    </div>
  ))}
</div>

</div>

    <div className='hidden md:block md:px-[40px] px-0 lg:px-0 biglg:px-0 xl:px-0'>
      <ExpenseTable
          onSearchData={onSearchData}
          handleSort={handleSort}
          handleSearch={handleExpenseSearch}
          meta={pagination}
          isLoading={isLoading}
          searchResult={searchResult}
          isSearching={isSearching}
          fetchMoreData={fetchMoreData}
          handleFilter={handleFilter}
          expenses={expenses}
          selectedFilter={filter}       />

    </div>

    <div className='flex md:hidden justify-center items-center'>
      <ExpenseTable
          onSearchData={onSearchData}
          handleSort={handleSort}
          handleSearch={handleExpenseSearch}
          meta={pagination}
          isLoading={isLoading}
          searchResult={searchResult}
          isSearching={isSearching}
          fetchMoreData={fetchMoreData}
          handleFilter={handleFilter}
          expenses={expenses}
          selectedFilter={filter} 
        
           />

    </div>
    </div>  
    </>
  );
};
export { ViewExpensePage };
